import { render, staticRenderFns } from "./df-page-promotion.vue?vue&type=template&id=b394e9f4"
import script from "./df-page-promotion.ts?vue&type=script&lang=js&external"
export * from "./df-page-promotion.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports